module.exports = __webpack_public_path__ + "static/media/mqjk.b7bc5f11.webm";